import React, { useState } from "react";
import Tippy from "@tippyjs/react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Icon, Icons } from "../Icon/Icon";
import { i18nCurrency } from "../../i18n";
import "./SectionPricing.css";

const SectionPricing = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [tab, setTab] = useState<number>(0);

    const data: any = [
        [
            {
                title: 'Single house',
                description: 'For those who have one unique house and own 3D model',
                items: {
                    'Standalone mode': true,
                    '3D modeling (3dsMax)': false,
                    '1x Exterior visualisation': true,
                    'Courtyard visualization': true,
                    '1x Interior visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': false,

                },
                isModel: false,
                price: i18nCurrency(3600),
            },
            {
                title: 'Multiple house',
                description: 'For those who have multiple unique house and own 3D models',
                items: {
                    'Standalone mode': true,
                    '3D modeling (3dsMax)': false,
                    '3x Exteriors visualisation': true,
                    'Courtyard visualization': true,
                    '5x Interiors visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': true,
                },
                isModel: false,
                price: i18nCurrency(6400),
            },
            {
                title: 'Apartment complex',
                description: 'For those who have a complex of multiple apartments and own 3D models',
                items: {
                    'Standalone mode': true,
                    '3D modeling (3dsMax)': false,
                    '5x Exteriors visualisation': true,
                    'Courtyard visualization': true,
                    '10x Interiors visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': true,
                },
                isModel: false,
                price: i18nCurrency(9800),
            }
        ],
        [
            {
                title: 'Single house',
                description: 'For those who have one unique house and need 3D model development',
                items: {
                    'Standalone mode': true,
                    '3D modeling (3dsMax)': true,
                    '1x Exterior visualisation': true,
                    'Courtyard visualization': true,
                    '1x Interior visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': false,
                },
                isModel: true,
                price: i18nCurrency(6800),
            },
            {
                title: 'Multiple house',
                description: 'For those who have a multiple unique houses and need 3D development',
                items: {
                    'Standalone mode': true,
                    '3D modeling (3dsMax)': true,
                    '3x Exteriors visualisation': true,
                    'Courtyard visualization': true,
                    '5x Interiors visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': true,
                },
                isModel: true,
                price: i18nCurrency(12600),
            },
            {
                title: 'Apartment complex',
                description: 'For those who have complex of a multiple apartments and need 3D development',
                items: {
                    'Standalone mode': true,
                    '3D modeling (3dsMax)': true,
                    '5x Exteriors visualisation': true,
                    'Courtyard visualization': true,
                    '10x Interiors visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': true,
                },
                isModel: true,
                price: i18nCurrency(23700),
            }
        ],
        [
            {
                title: 'Single house',
                description: 'For those who have one unique house and need 3D model development',
                items: {
                    'Pixel Streaming': true,
                    '3D modeling (3dsMax)': true,
                    '1x Exterior visualisation': true,
                    'Courtyard visualization': true,
                    '1x Interior visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': false,
                },
                isModel: true,
                price: i18nCurrency(7100),
            },
            {
                title: 'Multiple house',
                description: 'For those who have a multiple unique houses and need 3D development',
                items: {
                    'Pixel Streaming': true,
                    '3D modeling (3dsMax)': true,
                    '3x Exteriors visualisation': true,
                    'Courtyard visualization': true,
                    '5x Interiors visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': true,
                },
                isModel: true,
                price: i18nCurrency(13700),
            },
            {
                title: 'Apartment complex',
                description: 'For those who have complex of a multiple apartments and need 3D development',
                items: {
                    'Pixel Streaming': true,
                    '3D modeling (3dsMax)': true,
                    '5x Exteriors visualisation': true,
                    'Courtyard visualization': true,
                    '10x Interiors visualisation': true,
                    'Advanced environment': true,
                    'Integrate with another soft': true,
                },
                isModel: true,
                price: i18nCurrency(25300),
            }
        ],
    ];

    const scrollToAnchor = (anchor: string, location: string | null = '/') => {
        if (location) {
            navigate(location);
        }

        setTimeout(() => {
            document.body.className = '';
            window.scrollTo(0, document.getElementById(anchor)!.offsetTop - 106);
        }, 300);
    };

    return (
        <section id="pricing" className="pricing">
            <h2 className="wow fadeInDown">
                <Trans i18nKey="pricing.title">Pricing</Trans>
            </h2>
            <p className="description wow fadeInDown">
                <Trans i18nKey="pricing.description">
                    Knowing the diverse customer needs, we’ve prepared precisely laid out pricing plans for each option,
                    as well as the possibility of custom project pricing
                </Trans>
            </p>
            <nav aria-label="Tabs" className="wow fadeInDown">
                <span
                    className={tab === 0 ? 'active' : ''}
                    onClick={() => setTab(0)}
                >
                    <Trans i18nKey="pricing.tabs.0.title">Basic (w/o 3D)</Trans>
                </span>
                <span
                    className={tab === 1 ? 'active' : ''}
                    onClick={() => setTab(1)}
                >
                    <Trans i18nKey="pricing.tabs.1.title">Basic (with 3D)</Trans>
                </span>
                <span
                    className={tab === 2 ? 'active' : ''}
                    onClick={() => setTab(2)}
                >
                    <Trans i18nKey="pricing.tabs.2.title">Advanced (with 3D)</Trans>
                </span>
            </nav>
            <div className="container">
                {data[tab].map((item: any, index: number) => (
                    <div key={index} className={`item wow fadeIn${index === 0 ? 'Left' : index === 1 ? '' : 'Right'}`}>
                        <h4>
                            <Trans i18nKey={`pricing.tabs.${tab}.items.${index}.title`}>{item.title}</Trans>
                        </h4>
                        <p className="item-description">
                            <Trans i18nKey={`pricing.tabs.${tab}.items.${index}.description`}>{item.description}</Trans>
                        </p>
                        <ul>
                            {Object.keys(item.items).map((feature, fIndex) => {
                                const key = `pricing.tabs.${tab}.items.${index}.features.${fIndex}.tippy`;
                                let tippy = t(key);

                                return (
                                    <li key={fIndex} className={!item.items[feature] ? 'disabled' : ''}>
                                        <div>
                                            <Icon icon={Icons.PricingStar} width={11} height="100%"/>
                                            <span>
                                            <Trans i18nKey={`pricing.tabs.${tab}.items.${index}.features.${fIndex}`}>
                                                {feature}
                                            </Trans>
                                        </span>
                                        </div>
                                        {tippy !== key && (
                                            <Tippy content={tippy}>
                                                <Icon icon={Icons.CalculatorTip} width={18} height={18}/>
                                            </Tippy>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                        <div className="price">
                            <div>
                                <span>
                                    <Trans i18nKey="pricing.from">From</Trans>
                                </span>
                                <b><Trans i18nKey="currency.symbol">$</Trans> {item.price}</b>
                            </div>
                            {item.isModel && (
                                <p>
                                    <Trans i18nKey="pricing.withDevelopment">With 3D Development</Trans>
                                </p>
                            )}
                            {!item.isModel && (
                                <p>
                                    <Trans i18nKey="pricing.withoutDevelopment">Without 3D Development</Trans>
                                </p>
                            )}
                        </div>
                        <button className="white" onClick={() => scrollToAnchor('contact')}>
                            <Trans i18nKey="pricing.button">Book a call</Trans>
                        </button>
                    </div>
                ))}
            </div>
            <div className="calculator wow fadeInUp">
                <div className="content">
                    <div className="title">
                        <h3>
                            <Trans i18nKey="pricing.calculator.title">Calculate custom price</Trans>
                        </h3>
                        <div>
                            <Icon icon={Icons.PricingLightning} width={17} height="100%" />
                            <span>
                                <Trans i18nKey="pricing.calculator.tag">Individual pricing project</Trans>
                            </span>
                        </div>
                    </div>
                    <p>
                        <Trans i18nKey="pricing.calculator.description">
                            Knowing the diverse customer needs, we’ve prepared precisely laid out pricing plans for each
                            option, as well as the possibility of custom project pricing
                        </Trans>
                    </p>
                    <button className="white" onClick={() => scrollToAnchor('calculator', '/calculator')}>
                        <span>
                            <Trans i18nKey="pricing.calculator.button">See calculator</Trans>
                        </span>
                        <Icon icon={Icons.PricingArrow} width={40} height="100%"/>
                    </button>
                </div>
                <img src="/img/calculator.png" alt="Calculator"/>
            </div>
        </section>
    );
}

export default SectionPricing;
